<template>
  <!DOCTYPE html><html>
    <head></head>
      <body style="font-family: 'Montserrat', sans-serif; color: #000000 !important;">
        <pre style="margin-top: 0px; margin-bottom: 10px; font-family: 'Montserrat', sans-serif; font-size: 40px; font-weight:900; text-align: center; text-transform: uppercase;">Pase en blanco</pre>
        <pre style="margin-top: 0px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 21px; font-weight:600; text-align: center; text-transform: uppercase">Comprobante no valido como pase de abordar</pre>
        <!--<span style="margin: 2px; font-size: 18px;">{{user.agencia_activa +' - '+ user.username +' -'}} <span>{{ boleto.created_at | moment('DD-MM-YYYY HH:mm') }}</span></span> -->
        <p style="margin-top: 5px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 31px; font-weight:700; text-align: center; text-transform: uppercase">
          No. Boleto: {{ boleto.id }}
        </p>
        <p style="margin-top: 5px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 31px; font-weight:700; text-align: center; text-transform: uppercase">
          Nombre pasajero: {{ boleto.nombre_pasajero }}
        </p>
        <p style="margin-top: 5px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 31px; font-weight:700; text-align: center; text-transform: uppercase">
          Folio: {{ boleto.clave_facturacion }}
        </p>
        <p style="margin-top: 0px; margin-bottom: 5px; font-family: 'Montserrat', sans-serif; font-size: 31px; font-weight:700; text-align: center; text-transform: uppercase">
          Valor: ${{ boleto.monto_total_pagar }}
        </p>
        <p style="margin-top: 10px; margin-bottom: 10px; margin-left:10px; margin-right: 10px; font-family: 'Montserrat', sans-serif; font-size: 17px; font-weight:600; text-align: center; text-transform: uppercase">
          Este comprobante puede ser confirmado en cualquiera de nuestros puntos de venta a lo largo del pais, sujeto a disponibilidad con vigencia de 30 dias.
        </p>
        <p style="margin-top: 20px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 20px; font-weight:600; text-align: left; text-transform: uppercase">
          {{user.username}}/{{boleto.created_at | moment('DDMMYYYY')}}/{{ boleto.created_at | moment('HH:mm') }} 
        </p>
        <pre style="margin-top: 4px; font-family: 'Montserrat', sans-serif; font-size: 18px; font-weight:600; text-align: center; text-transform: uppercase;">Para facturar, conoce el aviso de privacidad y nuestras políticas comerciales en www.platinumline.mx</pre>
      </body>
    </html>
</template>
<script>
export default { 
props: {
  boleto: {required: false},
  user: {required: false},
},

mounted(){
},

data() {
    return {
     
    };
  },
}
</script>
<style scoped> 
body{
font-family: 'Montserrat', sans-serif !important;
}
</style>